import React from 'react';
import classNames from 'classnames';
import PropTypes from 'prop-types';
import css from './ListWithImages.module.css';
import { IconArrow } from '../../../components';

const ListWithImages = ({ className, rootClassName, config, onLinkClick }) => {
  const classes = classNames(rootClassName || css.root, className);
  const navConfig = config.config.navConfig;
  const asideConfig = config.config.aside;
  const mainLabel = config.config.mainLabel;

  const mainItems = navConfig.filter(m => m.id !== 'other');
  const otherItems = navConfig.filter(m => m.id === 'other');

  return (
    <div className={classes}>
      <div className={css.menuSection}>
        {mainLabel && mainItems.length > 0 ? (
          <div className={css.mainGroup}>
            <h3 className={css.menuHeading}>{mainLabel}</h3>
            <div className={css.mainCards}>
              {mainItems.map(m => (
                <div key={m.id} className={css.menu}>
                  {!m.hideTitle && <h3 className={css.menuHeading}>{m.label}</h3>}
                  <a href={m.link || '#'} className={css.cardWrapper} onClick={onLinkClick}>
                    {/*
                      Only render an <img> when there is a source. A post
                      without a featured image would otherwise show a broken
                      image box with its category as alt text.
                    */}
                    <div className={css.imageWrapper}>
                      {m.image ? (
                        <img src={m.image} alt={m.description || m.label} loading="lazy" />
                      ) : (
                        <span className={css.imageFallback} aria-hidden="true" />
                      )}
                    </div>
                    <p className={css.description}>{m.description}</p>
                  </a>
                </div>
              ))}
            </div>
          </div>
        ) : (
          /* No label: cards render directly. An empty list renders nothing,
             so a feed outage leaves no orphaned heading behind. */
          mainItems.map(m => (
            <div key={m.id} className={css.menu}>
              {!m.hideTitle && <h3 className={css.menuHeading}>{m.label}</h3>}
              <a href={m.link || '#'} className={css.cardWrapper} onClick={onLinkClick}>
                <div className={css.imageWrapper}>
                  <img src={m.image} alt={m.label} loading="lazy" />
                </div>
                <p className={css.description}>{m.description}</p>
              </a>
            </div>
          ))
        )}

        {otherItems.map(m => (
          <div key={m.id} className={classNames(css.menu, css.otherMenu)}>
            <h3 className={css.menuHeading}>{m.label}</h3>
            <ul>
              {m.config.map(item => (
                <li key={item.id}>
                  <a href={item.link} onClick={onLinkClick}>{item.label}</a>
                </li>
              ))}
            </ul>
          </div>
        ))}

        {asideConfig && (
          <aside className={css.aside}>
            <h3 className={css.title}>{asideConfig.title}</h3>
            <p className={css.description}>{asideConfig.description}</p>
            <div className={css.image}>
              <img src={asideConfig.image} alt={asideConfig.imageAlt} loading="lazy" />
            </div>
            <div className={css.asideLink}>
              <a href={asideConfig.link.link} onClick={onLinkClick}>
                {asideConfig.link.label}
                <IconArrow direction="right" size="small" aria-hidden="true" />
              </a>
            </div>
          </aside>
        )}
      </div>
    </div>
  );
};

ListWithImages.propTypes = {
  rootClassName: PropTypes.string,
  className: PropTypes.string,
  onLinkClick: PropTypes.func,
  config: PropTypes.shape({
    config: PropTypes.shape({
      navConfig: PropTypes.array.isRequired,
      aside: PropTypes.shape({
        title: PropTypes.string,
        description: PropTypes.string,
        image: PropTypes.string,
        imageAlt: PropTypes.string,
        link: PropTypes.shape({ link: PropTypes.string, label: PropTypes.string }),
      }),
    }),
  }).isRequired,
};

export default ListWithImages;